import { render, staticRenderFns } from "./DepublishPage.vue?vue&type=template&id=12590cf6&scoped=true"
import script from "./DepublishPage.vue?vue&type=script&lang=js"
export * from "./DepublishPage.vue?vue&type=script&lang=js"
import style0 from "./DepublishPage.vue?vue&type=style&index=0&id=12590cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12590cf6",
  null
  
)

export default component.exports